import {Component, Fragment} from "inferno";
import {Button} from "inferno-bootstrap";
import Send from "inferno-feather/dist/icons/send";

import {App} from "../../../App";
import {Tooltip} from "../../../components/Tooltip";
import {AppState} from "../../../services/configuration";
import {Logger} from "../../../services/logger";
import {Bundle} from "../../../services/translationProvider";
import {Level} from "../../../utils/types";
import {CharacterLimit} from "./CharacterLimit";
import {ChatMessageFormat} from "@sap/cpaas-commlib-lib";

export type Props = { onPasteFiles: (files: File[]) => void, active: boolean };
export type State = { input: string, overflow: boolean };

export class Input extends Component<Props, State> {
	state: State = {
		input: "",
		overflow: false,
	};
	private textArea: any;
	private maxCharacters: number = 4000;
	private typing: any;

	checkInputLimit = () => {
		return (this.maxCharacters - this.state.input.length <= 100);
	};

	addText = (text: string) => {
		this.textArea.value = (this.textArea.value + text).substring(0, this.maxCharacters);
		this.setState({input: this.textArea.value, overflow: this.textArea.value === "" ? false : (this.state.overflow || (this.textArea.scrollHeight > this.textArea.clientHeight))});
	};

	handleChange = (event: any) => {
		let msg = this.textArea.value.trim();
		this.setState({input: this.textArea.value, overflow: msg === "" ? false : (this.state.overflow || (event.target.scrollHeight > event.target.clientHeight))});
		if (event instanceof KeyboardEvent && (event.key !== "Enter" || event.key === "Enter" && event.shiftKey) || msg === "") {
			if (!this.typing) {
				AppState.activeLeg.typing(true).catch(() => Logger.warning("Set indicator fail"));
				this.typing = setTimeout(this.onTypingOff, 2000);
			}
			return;
		}
		msg = msg.replace(/(?:\r\n|\r|\n)/g, "<br>");
		AppState.activeLeg.sendMessage(msg, ChatMessageFormat.text).catch(() => {
			App.ShowMsg("VCC_XMSG_ALERT_SEND", Level.Danger);
		});

		if (this.typing) {
			clearTimeout(this.typing);
			this.onTypingOff();
		}
		this.textArea.value = "";
		this.setState({input: "", overflow: false});
		event.stopPropagation();
		event.preventDefault();
	};

	onTypingOff = () => {
		AppState.activeLeg.typing(false).catch(() => {
			Logger.warning("Set indicator fail");
		});
		this.typing = null;
	};

	onPaste = (event: ClipboardEvent) => {
		if (event.clipboardData.files.length > 0) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onPasteFiles(Array.from(event.clipboardData.files));
		}
	};

	onInput = () => {
		this.forceUpdate();
	}

	render() {
		const sendDisabled: boolean = !this.props.active || this.textArea?.value?.length === 0;
		return (
			<Fragment>
				{this.checkInputLimit() && <CharacterLimit maxCharacters={this.maxCharacters} currentlyTyped={this.state.input.length}/>}
				<div className="d-flex border-top border-bottom chat-input-root align-items-center"
					 style={{height: (this.state.overflow ? "90px" : "55px")}}>
					<textarea maxLength={this.maxCharacters} disabled={!this.props.active || undefined} ref={(node: any) => this.textArea = node}
							  onKeyDown={this.handleChange} className="chat-input-textarea w-100 border-0 shadow-none p-2" rows={1}
							  placeholder={Bundle.t("VCC_XMSG_INPUT_PLACEHOLDER")} style={{
						height: (this.state.overflow ? "100%" : ""),
						overflow: (this.state.overflow ? "auto" : "hidden")
					}} onPaste={this.onPaste} onInput={this.onInput}/>
					<div class="d-flex justify-content-center align-items-center">
						<Button disabled={sendDisabled || undefined} color={sendDisabled ? Level.Link : Level.Primary}
								onClick={this.handleChange} className="m-2">
							<Send id="send-btn" className={sendDisabled ? "text-primary" : ""}/>
							<Tooltip target="send-btn" content="VCC_XTOL_CHAT_SEND_TOOLTIP" placement="top"/>
						</Button>
					</div>
				</div>
			</Fragment>
		);
	}
}
